<template>
    <div class="room-theme-switch" role="group" aria-label="选择房间主题">
        <button v-for="item in themes" :key="item.id" type="button"
                class="room-theme-option" :class="{ 'is-selected': state.current === item.id }"
                :aria-pressed="state.current === item.id" :title="item.label + '主题'"
                @click="select(item.id)">
            <span class="room-theme-dot" :style="{ backgroundColor: item.color }" aria-hidden="true"></span>
            {{ item.label }}
        </button>
    </div>
</template>

<script>
import { roomThemes, themeState, setRoomTheme } from '../themes';

export default {
    name: 'ThemeSwitcher',
    data: () => ({ themes: roomThemes, state: themeState }),
    methods: { select: setRoomTheme }
};
</script>
